import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiUrl } from '../../config/api';
import { RootState } from '../index';

export interface WebhookData {
  id: number;
  agent_id: number;
  payload: any;
  timestamp: string;
  created_at: string;
}

export const webhooksApi = createApi({
  reducerPath: 'webhooksApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl('/api/v1/webhooks'),
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
        console.log('🔑 Webhook API: Added auth token to headers');
      } else {
        console.warn('⚠️ Webhook API: No auth token found in state');
      }
      return headers;
    },
  }),
  tagTypes: ['WebhookData'],
  endpoints: (builder) => ({
    getLastWebhookData: builder.query<WebhookData, number>({
      query: (agentId) => `/${agentId}/last-data`,
      providesTags: (result, error, agentId) => [
        { type: 'WebhookData', id: agentId },
      ],
    }),
  }),
});

export const {
  useGetLastWebhookDataQuery,
} = webhooksApi;
